import React from 'react';
import { McButton, McCard, McInput, McNumberStepper } from '@maersk-global/mds-react-wrapper';
import { TerminalSelect } from '../components/Common/TerminalSelect';
import { dbBreakglassTerminalIds } from '../utils/terminalConfig';
import { ConfirmationDialog } from '../components/Common/ConfirmationDialog';
import {
    MAX_DURATION_HOURS,
    MIN_DURATION_HOURS,
    useDbBreakglassRequestController,
} from '../hooks/useDbBreakglassRequestController';

const DbBreakglassRequestPage: React.FC = () => {
    const {
        terminalCode, setTerminalCode,
        incidentNumber, setIncidentNumber, isIncidentValid,
        duration, setDuration,
        confirmOpen, setConfirmOpen,
        canSubmit, isSubmitting, submit,
    } = useDbBreakglassRequestController();

    return (
        <div style={{ maxWidth: 640, margin: '0 auto', padding: '1.5rem' }}>
            <McCard heading="Raise DB Breakglass Request" fit="medium">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '0.5rem 0' }}>
                    <TerminalSelect
                        value={terminalCode}
                        onChange={setTerminalCode}
                        additionalFilter={dbBreakglassTerminalIds}
                        required
                        style={{ width: '100%' }}
                    />
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <div style={{ flex: 6, minWidth: 0 }}>
                            <McInput
                                label="Incident number"
                                value={incidentNumber}
                                onInput={(e: any) => setIncidentNumber(e.target.value)}
                                required
                                invalid={incidentNumber !== '' && !isIncidentValid}
                                errormessage="Enter a valid incident number (e.g. INC1234567)"
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div style={{ flex: 4, minWidth: 0 }}>
                            <McNumberStepper
                                label={`Duration (hours, ${MIN_DURATION_HOURS}-${MAX_DURATION_HOURS})`}
                                min={MIN_DURATION_HOURS}
                                max={MAX_DURATION_HOURS}
                                step={1}
                                value={duration}
                                input={(e: any) => setDuration(e.target.value)}
                                required
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <McButton
                            label="Submit"
                            appearance="primary"
                            disabled={!canSubmit || confirmOpen || isSubmitting}
                            onClick={() => setConfirmOpen(true)}
                        />
                    </div>
                </div>
            </McCard>

            <ConfirmationDialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={submit}
                title="Raise DB breakglass request?"
                content={`This will raise a DB breakglass request for terminal ${terminalCode} against incident ${incidentNumber} for ${duration} hour(s).`}
                confirmLabel="Raise request"
                variant="danger"
                loading={isSubmitting}
            />
        </div>
    );
};

export default DbBreakglassRequestPage;
